import React, { Component, PropTypes } from 'react';

export default class Alert extends Component {
	static propTypes = {
		alertMessage: PropTypes.oneOfType([
			PropTypes.string,
			PropTypes.object
		]).isRequired,
		alertType: PropTypes.string.isRequired,
		id: PropTypes.string.isRequired,
		decoratorClass: PropTypes.string,
		qaSelector: PropTypes.string
	};
	render() {
		const {
			id,
			alertMessage,
			alertType,
			decoratorClass,
			qaSelector
		} = this.props;

		return (
			<div className={`dna-alert dna-alert-${alertType} ${decoratorClass === undefined ? '' : decoratorClass}`}
				key={id}
				data-qa={qaSelector}>
				<div className="dna-alert-body">
					<p>{ alertMessage }</p>
				</div>
			</div>
		);
	}
}



// WEBPACK FOOTER //
// ../~/dna-alert/components/alert/Alert.jsx